export enum CONTACT_INFO_LIBRARY_ASSET_KEYS {
  LEAF_ICON = 'LEAF_ICON',
  BACK_GRAY_ICON = 'BACK_GRAY_ICON',
  DOWN_ICON = 'DOWN_ICON',
  UP_ICON = 'UP_ICON',
  SUCCESS_ICON = 'SUCCESS_ICON',
  FAILURE_ICON = 'FAILURE_ICON',
  ATTENTION_ICON = 'ATTENTION_ICON',
}

export type FormInput = {
  address1: string;
  address2?: string;
  city: string;
  state: string;
  zip: string;
  homePhone: string;
  workPhone: string;
  mobilePhone: string;
  email: string;
};

export type FormFields = {
  type: string;
  label: string;
  id: string;
  onChange: (x: {}) => void;
  onBlur: (x: {}) => void;
  onKeyPress: (x: {}) => void;
  val: string;
  err: string;
  disable: boolean;
};

export type ContactFieldDisabled = {
  address1Disable: boolean;
  address2Disable: boolean;
  cityDisable: boolean;
  stateDisable: boolean;
  zipDisable: boolean;
  homePhoneDisable: boolean;
  workPhoneDisable: boolean;
  mobilePhoneDisable: boolean;
  emailDisable: boolean;
};

export type AllContactValue = {
  mobilePhone: string;
  homePhone: string;
  workPhone: string;
  textPhone: string;
};

export type ContactInfoLibraryAssets = Record<
  CONTACT_INFO_LIBRARY_ASSET_KEYS,
  unknown
>;
